document.getElementById("newsletter-form")?.addEventListener("submit", function(e) {
    e.preventDefault();

    let form = this;
    let msg = document.getElementById("newsletter-msg");
    let url = form.action + "&" + new URLSearchParams(new FormData(form)).toString();

    if (msg) {
      msg.innerHTML = "Processing...";
      msg.style.color = "#555";
    }

    fetch(url, {
        method: "GET",
        mode: "no-cors"
    })
    .then(() => {
        if (msg) {
          msg.innerHTML = "You're subscribed!";
          msg.style.color = "green";
        }
        form.reset();
    })
    .catch(() => {
        if (msg) {
          msg.innerHTML = "Something went wrong. Try again.";
          msg.style.color = "red";
        }
    });
});
/* ==========================================================
   Platina: Variant-specific image galleries (no Liquid edits)
   Uses image ALT tags like:
     Pack-only product:      Fly fan [2 set]
     Pack+Color product:     Fly fan [silver][2 pack]
                             Fly fan [champagne gold][single]

   Behavior:
   - Untagged images (no [brackets]) are ALWAYS shared (always show)
   - Tagged images only show when they match the current selection
   - If at least one tagged image matches, non-matching tagged images are hidden
   - If NO tagged images match, show everything (prevents blank gallery)

   UI Fix:
   - Forces "Color: X" to update
   - Forces "Pack Size: X" (or "Pack: X" / "Size: X") to update
   ========================================================== */
(function () {
  /* ------------------ Helpers ------------------ */
  function normalizeValue(v) {
    return (v || "")
      .toString()
      .trim()
      .toLowerCase()
      .replace(/\s+/g, " ")
      .replace(/-/g, " "); // treat hyphens like spaces
  }

  function isVisible(el) {
    return !!(el && el.offsetParent !== null);
  }

  function getRoot() {
    // Prefer the main product section if possible
    return (
      document.querySelector("main") ||
      document.querySelector(".shopify-section") ||
      document.body
    );
  }

  /* ------------------ Read current selections (ALL options) ------------------ */
  function getSelectedOptionLabels() {
    const root = getRoot();
    const values = [];

    // variant-selects dropdowns
    root.querySelectorAll("variant-selects select").forEach((sel) => {
      if (sel && isVisible(sel) && sel.value) values.push(normalizeValue(sel.value));
    });

    // variant-radios / swatches
    root.querySelectorAll("variant-radios fieldset").forEach((fs) => {
      if (!isVisible(fs)) return;
      const checked = fs.querySelector('input[type="radio"]:checked');
      if (checked && checked.value) values.push(normalizeValue(checked.value));
    });

    // fallback radios
    root.querySelectorAll('input[type="radio"][name^="options"]:checked').forEach((r) => {
      if (isVisible(r) && r.value) values.push(normalizeValue(r.value));
    });

    // fallback selects like options[Option1]
    root.querySelectorAll('select[name^="options["]').forEach((sel) => {
      if (sel && isVisible(sel) && sel.value) values.push(normalizeValue(sel.value));
    });

    return Array.from(new Set(values)).filter(Boolean);
  }

  /* ------------------ ALT tag parsing ------------------ */
  function extractTagsFromAlt(alt) {
    const a = normalizeValue(alt);
    const match = a.match(/\[(.*?)\]/g);
    if (!match) return null; // no bracket tags => shared

    const tags = match
      .map((t) => t.replace(/[\[\]]/g, ""))
      .map((t) => normalizeValue(t));

    return tags.length ? tags : null;
  }

  function slideMatchesSelection(slideTags, selectedOptions) {
    // null = untagged (shared)
    if (slideTags === null) return null;

    const sel = new Set(selectedOptions.map(normalizeValue));

    // IMPORTANT:
    // If an image has multiple tags [silver][2 pack], it should only show
    // when ALL of those tags are present in the selected options.
    return slideTags.every((tag) => sel.has(tag));
  }

  /* ------------------ Gallery filter ------------------ */
  function filterGallery() {
    const selected = getSelectedOptionLabels();
    if (!selected.length) return;

    const galleries = document.querySelectorAll(
      "media-gallery, .product__media-gallery, .product-media-gallery"
    );
    if (!galleries.length) return;

    galleries.forEach((gallery) => {
      const slides = gallery.querySelectorAll(".product__media-item, li[id^='Slide-']");
      const thumbs = gallery.querySelectorAll(".thumbnail-list__item, li[id^='Slide-Thumbnails-']");

      let anyTaggedMatch = false;

      // Pass 1: detect if any tagged images match the current selection
      slides.forEach((slide) => {
        const img = slide.querySelector("img");
        const alt = img ? (img.getAttribute("alt") || "") : "";
        const tags = extractTagsFromAlt(alt);
        const match = slideMatchesSelection(tags, selected);
        if (match === true) anyTaggedMatch = true;
      });

      // Pass 2: show/hide slides
      slides.forEach((slide) => {
        const img = slide.querySelector("img");
        const alt = img ? (img.getAttribute("alt") || "") : "";
        const tags = extractTagsFromAlt(alt);
        const match = slideMatchesSelection(tags, selected);

        // show rules:
        // - if no tagged images matched, show everything
        // - else show (matches) OR (untagged shared)
        const show = !anyTaggedMatch ? true : (match === true || match === null);

        slide.style.display = show ? "" : "none";
      });

      // Thumbnails mirror slide visibility
      thumbs.forEach((thumb) => {
        const target = thumb.getAttribute("data-target");
        if (!target) return;

        const targetSlide =
          gallery.querySelector(`[data-media-id="${target}"]`) ||
          gallery.querySelector(`#Slide-${target}`) ||
          gallery.querySelector(`[id*="${target}"]`);

        if (targetSlide) {
          thumb.style.display = (targetSlide.style.display === "none") ? "none" : "";
        }
      });

      // Ensure active slide isn't hidden
      const active = gallery.querySelector(".product__media-item.is-active");
      if (active && active.style.display === "none") {
        const firstVisible = gallery.querySelector(".product__media-item:not([style*='display: none'])");
        if (firstVisible) {
          const id = firstVisible.getAttribute("data-media-id");
          const thumbBtn = gallery.querySelector(`.thumbnail-list__item[data-target="${id}"] button`);
          if (thumbBtn) thumbBtn.click();
        }
      }
    });
  }

  /* ------------------ UI label fixes (Color + Pack Size) ------------------ */
  function updateOptionLabels() {
    const root = getRoot();

    // ✅ FIX: update by OPTION GROUP (fieldset/select wrapper), not by guessing text around spans
    // This handles duplicated legends like:
    // <legend>Color: <span class="append-options-values">Silver</span></legend>
    // repeated multiple times.
    function setSpansInScope(scopeEl, value) {
      if (!scopeEl || !value) return;
      scopeEl.querySelectorAll("span.append-options-values").forEach((sp) => {
        sp.textContent = value;
      });
      // Dawn sometimes uses this too:
      scopeEl.querySelectorAll(".product-form__selected-value").forEach((sp) => {
        sp.textContent = value;
      });
    }

    // 1) variant-radios fieldsets (swatches/radios)
    root.querySelectorAll("variant-radios fieldset").forEach((fs) => {
      if (!isVisible(fs)) return;
      const checked = fs.querySelector('input[type="radio"]:checked');
      const val = checked && checked.value ? checked.value.trim() : "";
      if (!val) return;

      // Update all duplicates inside the fieldset
      setSpansInScope(fs, val);

      // Also update any duplicates the theme may have placed in the closest wrapper
      const wrap = fs.closest(".product-form__input") || fs.closest(".product-form") || fs.parentElement;
      setSpansInScope(wrap, val);
    });

    // 2) variant-selects selects (dropdown variants)
    root.querySelectorAll("variant-selects select").forEach((sel) => {
      if (!isVisible(sel) || !sel.value) return;
      const val = sel.value.trim();

      const wrap = sel.closest(".product-form__input") || sel.closest(".product-form") || sel.parentElement;
      setSpansInScope(wrap, val);
    });

    // 3) fallback selects like options[Option1]
    root.querySelectorAll('select[name^="options["]').forEach((sel) => {
      if (!isVisible(sel) || !sel.value) return;
      const val = sel.value.trim();

      const wrap = sel.closest(".product-form__input") || sel.closest(".product-form") || sel.parentElement;
      setSpansInScope(wrap, val);
    });
  }

  /* ------------------ Run reliably ------------------ */
  let queued = false;

  function runAll() {
    filterGallery();
    updateOptionLabels();
  }

  function scheduleAll() {
    if (queued) return;
    queued = true;

    requestAnimationFrame(() => {
      queued = false;
      runAll();

      // Extra passes to catch async theme updates
      setTimeout(runAll, 80);
      setTimeout(runAll, 180);
      setTimeout(runAll, 320);
    });
  }

  function attach() {
    scheduleAll();

    document.addEventListener("change", function (e) {
      const t = e.target;
      if (!t) return;

      const isVariantControl =
        (t.matches && t.matches("variant-selects select")) ||
        (t.matches && t.matches("variant-radios input[type='radio']")) ||
        (t.name && t.name.toLowerCase().includes("options")) ||
        (t.name && t.name.toLowerCase() === "id");

      if (isVariantControl) {
        setTimeout(scheduleAll, 30);
      }
    });

    document.addEventListener("variant:change", function () {
      setTimeout(scheduleAll, 30);
    });

    // swatch label click (your theme uses label.swatch-variant-color)
    document.addEventListener("click", function (e) {
      if (e.target.closest("label.swatch-variant-color")) {
        setTimeout(scheduleAll, 30);
      }
    });

    // ✅ FIX: watch for theme re-rendering the variant DOM and re-apply labels
    try {
      const root = getRoot();
      const target = root.querySelector("variant-radios") || root.querySelector("variant-selects") || root;
      const obs = new MutationObserver(() => {
        setTimeout(scheduleAll, 30);
      });
      obs.observe(target, { childList: true, subtree: true });
    } catch (err) {
      // ignore observer errors
    }

    // catch late-loaded gallery content
    window.addEventListener("load", function () {
      scheduleAll();
      setTimeout(scheduleAll, 200);
      setTimeout(scheduleAll, 600);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", attach);
  } else {
    attach();
  }
})();
/* ==========================================================
   Platina UI-only fix (DOES NOT TOUCH GALLERY)
   Fixes the displayed text for:
   - Color
   - Pack / Pack Size / Size
   - Set / Sets   (2 set / 4 set / 8 set)
   Works with spans like: <span class="append-options-values">...</span>
   And also plain text like: "Sets: 4-set"
   ========================================================== */
(function () {
  function isVisible(el) {
    return !!(el && el.offsetParent !== null);
  }

  function clean(v) {
    return (v || "").toString().trim();
  }

  // Reads Option1/Option2/Option3 reliably (select or radios) without guessing keywords
  function getOptionValue(n) {
    // Select dropdown
    const sel =
      document.querySelector(`variant-selects select[name="options[Option${n}]"]`) ||
      document.querySelector(`select[name="options[Option${n}]"]`);
    if (sel && sel.tagName === "SELECT" && sel.value) return clean(sel.value);

    // Radios by fieldset order (Platina/Dawn)
    const radio =
      document.querySelector(`variant-radios fieldset:nth-of-type(${n}) input[type="radio"]:checked`) ||
      document.querySelector(`input[type="radio"][name="options[Option${n}]"]:checked`);
    if (radio && radio.value) return clean(radio.value);

    return "";
  }

  function updateLabels() {
    const opt1 = getOptionValue(1); // usually Pack/Set
    const opt2 = getOptionValue(2); // usually Color
    const opt3 = getOptionValue(3); // if you ever have a 3rd option

    // ✅ FIX: update spans inside their closest option wrapper so duplicates are handled safely
    document.querySelectorAll("span.append-options-values").forEach((span) => {
      const wrap =
        span.closest("fieldset") ||
        span.closest(".product-form__input") ||
        span.closest(".product-form") ||
        span.parentElement;

      if (!wrap) return;

      const txt = (wrap.textContent || "").toLowerCase();

      // Color line -> Option2
      if (txt.includes("color") && opt2) {
        wrap.querySelectorAll("span.append-options-values").forEach((sp) => sp.textContent = opt2);
        return;
      }

      // Sets / Pack / Size line -> Option1
      if ((txt.includes("set") || txt.includes("pack") || txt.includes("size")) && opt1) {
        wrap.querySelectorAll("span.append-options-values").forEach((sp) => sp.textContent = opt1);
        return;
      }
    });

    // Fix plain text nodes like "Sets: 4-set" or "Pack Size: Single"
    document.querySelectorAll("*").forEach((node) => {
      if (!node || node.childNodes.length !== 1) return;
      if (node.childNodes[0].nodeType !== Node.TEXT_NODE) return;

      const t = (node.textContent || "").trim();

      // Color
      if (/^\s*color\s*:\s*/i.test(t) && opt2) {
        node.textContent = "Color: " + opt2;
        return;
      }

      // Sets / Set / Pack / Pack Size / Size
      if (/^\s*(sets?|pack(\s*size)?|size)\s*:\s*/i.test(t) && opt1) {
        const prefix = (t.match(/^\s*(sets?|pack(\s*size)?|size)\s*:/i) || [])[1] || "Pack Size";
        // Preserve the same label ("Sets:" stays "Sets:")
        node.textContent = prefix.replace(/\s+/g, " ").replace(/^\w/, c => c.toUpperCase()) + ": " + opt1;
        return;
      }
    });
  }

  function schedule() {
    updateLabels();
    setTimeout(updateLabels, 50);
    setTimeout(updateLabels, 150);
    setTimeout(updateLabels, 350);
  }

  // initial
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", schedule);
  } else {
    schedule();
  }

  // changes
  document.addEventListener("change", function (e) {
    const t = e.target;
    if (!t) return;

    const isVariantControl =
      (t.matches && t.matches("variant-selects select")) ||
      (t.matches && t.matches("variant-radios input[type='radio']")) ||
      ((t.name || "").toLowerCase().includes("options"));

    if (isVariantControl) schedule();
  });

  document.addEventListener("variant:change", schedule);

  // swatch clicks
  document.addEventListener("click", function (e) {
    if (e.target.closest("label.swatch-variant-color")) schedule();
  });

  window.addEventListener("load", schedule);
})();
